<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" fixed app style="z-index: 1000;">
      <v-list dense>
        <v-list-tile
          v-for="item in navItems"
          :key="item.title"
          v-if="item.isVisible"
          @click="() => { routeTo(item.routeTo); drawer = false }"
          class="list-tile"
          :class="{'close-on-mobile': item.hideOnMobile}"
        >
          <div>
            <v-list-tile-action>
              <img :src="item.icon" />
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <span class="nav-title">{{ item.title }}</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </div>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="indigo" dark fixed app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="hide-on-mobile">Mostar Rock School</v-toolbar-title>
      <div style="position:absolute; right:15px; display:flex; align-items:center;">
        <span class="header-user-name">{{ userName }}</span>
        <hover-drop-down
          class="layout-change"
          :items="navigationSelector"
          :main-icon="userProfile || ''"
          :isBorderRadius="true"
          @itemSelected="navationItemChanged"
        ></hover-drop-down>
        <!-- <img class="header-profile" :src="userProfile" alt="Profile" /> -->
      </div>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout>
          <v-flex xs12>
            <router-view></router-view>
            <response-message v-if="responseMessageActive"></response-message>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import ResponseMessage from "./ResponseMessage";
import HoverDropDown from "./HoverDropDown";

import { bus } from "../main";
export default {
  components: {
    ResponseMessage,
    HoverDropDown
  },
  data() {
    return {
      userName: "",
      userProfile: "",
      drawer: false,
      navigationSelector: [
        {
          text: 'Odjava',
          value: 'logout'
        }
      ],
      navItems: [
        {
          title: "Raspored",
          icon: "https://img.icons8.com/ios/50/000000/planner.png",
          routeTo: "Appointments",
          isVisible: true,
          hideOnMobile: false
        },
        {
          title: "Korisnici",
          icon: "https://img.icons8.com/ios/50/000000/user-group-man-man.png",
          routeTo: "Users",
          isVisible: true,
          hideOnMobile: false,
          isVisible: this.$store.state.services.checkRole("Administrator") || this.$store.state.services.checkRole("Profesor") || this.$store.state.services.checkRole("Supervizor")
        },
        {
          title: "Instrumenti",
          icon: "https://img.icons8.com/ios/50/000000/jazz.png",
          routeTo: "Instruments",
          isVisible: true,
          hideOnMobile: true,
          isVisible: this.$store.state.services.checkRole("Administrator")
        },
        {
          title: "Tipovi termina",
          icon: "https://img.icons8.com/ios/50/000000/type.png",
          routeTo: "AppointmentTypes",
          isVisible: true,
          hideOnMobile: true,
          isVisible: this.$store.state.services.checkRole("Administrator")
        },
        {
          title: "Studio",
          icon: "https://img.icons8.com/ios/50/000000/vertical-settings-mixer.png",
          routeTo: "Studio",
          isVisible: true,
          hideOnMobile: true,
          isVisible: this.$store.state.services.checkRole("Administrator")
        },
        {
          title: "Svi termini",
          icon: "https://img.icons8.com/ios/50/000000/overtime.png",
          routeTo: "AllAppointments",
          isVisible: true,
          hideOnMobile: true,
          isVisible: this.$store.state.services.checkRole("Administrator")
        },
        {
          title: "Prijava kvara",
          icon: "https://img.icons8.com/ios/50/000000/add-list.png",
          routeTo: "FailureReport",
          isVisible: true,
          hideOnMobile: false,
          isVisible: true,
        },
        {
          title: "Prijavljeni kvarovi",
          icon: "https://img.icons8.com/ios/50/000000/report-card.png",
          routeTo: "FailureList",
          isVisible: true,
          hideOnMobile: true,
          isVisible:
            this.$store.state.services.checkRole("Tehničar") ||
            this.$store.state.services.checkRole("Administrator")
        },
        {
          title: "Financije",
          icon: "https://img.icons8.com/ios/50/000000/budget.png",
          routeTo: "PaymentsList",
          isVisible: true,
          hideOnMobile: false,
          isVisible: this.$store.state.services.checkRole("Administrator")
        },
        {
          title: "Profil",
          icon: "https://img.icons8.com/ios/50/000000/contacts.png",
          routeTo: "Profile",
          isVisible: true,
          hideOnMobile: false
        }
      ]
    };
  },
  computed: {
    responseMessageActive() {
      return this.$store.getters.isResponseMessageActive;
    }
  },
  methods: {
    logout() {
      localStorage.setItem("user-roles", "");
      localStorage.setItem("user-token", "");
      localStorage.clear('unpaid-subscription');
      this.$store.state.services.resetAxiosHeader();
      this.$router.push("/");
    },
    navationItemChanged(item){
      if(item === 'logout'){
        this.logout();
      }
    },
    routeTo(route) {
      this.$router.push({ name: route })
    }
  },
  created() {
    this.userName = localStorage.getItem("user-name");
    this.userProfile = localStorage.getItem("user-profile");
    bus.$on("profileImageChanged", data => {
      this.userProfile = localStorage.getItem("user-profile");
    });
  }
  // computed:{
  //   windowWidth(){
  //     return document.documentElement.clientWidth;
  //   }
  // }
};
</script>
<style scoped>
.list-tile {
  margin: 5px 0;
}
.v-list__tile__action {
  display: inline-block !important;
  min-width: auto !important;
  padding: 0 10px;
}
.nav-title {
  font-size: 14px;
}
img {
  width: 25px;
}
.v-list__tile__content {
  display: inline-block !important;
}
.header-profile {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.header-user-name {
  line-height: 30px;
  margin-right: 10px;
  vertical-align: top;
}
@media (max-width: 768px) {
  .hide-on-mobile {
    display: none;
  }
  .close-on-mobile {
    display: none;
  }
}
</style>

